export const COLLAPSIBLE_ARRAOW_ICON_SIZE = 10;
export const ICON_SIZE_IN_PIXEL = 16;
export const BUSINESS_STATUS_OPEN_NOW = 'openNow';
export const BUSINESS_STATUS_CLOSED_NOW = 'closedNow';
export const BUSINESS_STATUS_CLOSING_SOON = 'closingSoon';
export const BUSINESS_STATUS_OPENS_SOON = 'opensSoon';
